import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { formatRepublicanDateFromDateParts } from '../../../../../../helpers/collaborativeIndexations'
import { isEmpty } from '../../../../../../helpers/sanityChecks'

class Republican extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        value: PropTypes.object.isRequired,
    }

    render()
    {
        if(isEmpty(this.props.value))
        {
            return null
        }

        const republicanDate = formatRepublicanDateFromDateParts(this.props.value.parts, this.props.t)

        return (
            <span title={ republicanDate }>
                { republicanDate }
            </span>
        )
    }
}

export default withTranslation()(Republican)
